export default function Logo({ width = 210, dark = false }) {
  const textColor = dark ? "#ffffff" : "#0A1128";
  const iconStroke = dark ? "#e2e8f0" : "#334155";
  const dotFill = dark ? "#e2e8f0" : "#334155";
  const ratio = width / 210;
  const height = Math.round(45 * ratio);

  return (
    <svg width={width} height={height} viewBox="0 0 220 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="5" y1="20" x2="15" y2="20" stroke="#4F46E5" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="2" y1="26" x2="18" y2="26" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="8" y1="32" x2="14" y2="32" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M22 15H42L38 32H26L22 15Z" stroke={iconStroke} strokeWidth="2" strokeLinejoin="round"/>
      <path d="M22 15L20 10H16" stroke={iconStroke} strokeWidth="2" strokeLinecap="round"/>
      <circle cx="28" cy="40" r="2" fill={dotFill}/>
      <circle cx="38" cy="40" r="2" fill={dotFill}/>
      <text x="25" y="26" fill="#4F46E5" fontFamily="Plus Jakarta Sans, sans-serif" fontWeight="800" fontSize="12">t</text>
      <text x="31" y="26" fill="#f97316" fontFamily="Plus Jakarta Sans, sans-serif" fontWeight="800" fontSize="12">c</text>
      <path d="M36 18L41 13M41 12H37M41 12V16" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <text x="45" y="14" fill={textColor} fontFamily="Plus Jakarta Sans, sans-serif" fontWeight="600" fontSize="9">.net</text>
      <text x="55" y="34" fill={textColor} fontFamily="Plus Jakarta Sans, sans-serif" fontWeight="700" fontSize="21">TuCatálogo</text>
      <text x="172" y="34" fill="#f97316" fontFamily="Plus Jakarta Sans, sans-serif" fontWeight="700" fontSize="21">.net</text>
    </svg>
  );
}
